import {isFlatReport, reportUnits, FLAT_REPORT_STAKE, reportMoney} from './brainFlatReporting';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { authHeader } from '../api/auth';

type Bet = {date:string;race_id:string;track:string;race:string;off_at:string;runner:string;core_rank:number;brain_prob:number;result:string;bsp:number|null;benchmark_pnl_units:number|null};
type Summary = {selected:number;settled:number;wins:number;priced_bets:number;missing_price:number;pending:number;voids:number;roi_pct:number|null;pnl_units:number};
type Report = {rows:Bet[];summary:Summary};
export default function HistoricalBrainBets({streamId}:{streamId:string}) {
 const [sample,setSample]=useState('historical'),[from,setFrom]=useState(''),[to,setTo]=useState(''),[page,setPage]=useState(0);
 const [data,setData]=useState<Report|null>(null),[error,setError]=useState(''),[loading,setLoading]=useState(false);
 useEffect(()=>{
  let active=true;
  const fetchRows=()=>{setLoading(true);setError('');
   axios.get(API_BASE_URL+'/api/strategy/trained-brain-bets',{headers:authHeader(),params:{stream:streamId,sample,from,to}})
   .then(r=>{if(active)setData(r.data);}).catch(()=>{if(active){setError('Could not load stream bets.');setData(null);}})
   .finally(()=>{if(active)setLoading(false);});
  };
  setData(null);setPage(0);fetchRows();const timer=window.setInterval(fetchRows,60000);
  return()=>{active=false;window.clearInterval(timer);};
 },[streamId,sample,from,to]);
 const fmt=(x:number|null|undefined,suffix='')=>x==null?'—':x.toFixed(2)+suffix;
 const rows=data?.rows.slice(page*100,(page+1)*100)||[];
 return <div style={{marginTop:12}}>
  <div className="brain-filter">
   <label>Results <select aria-label="Stream result period" value={sample} onChange={e=>setSample(e.target.value)} style={{padding:7}}>
    <option value="historical">Backdated 2026</option><option value="prospective">Prospective paper</option>
   </select></label>
   <label>From <input aria-label="Bets from date" type="date" value={from} onChange={e=>setFrom(e.target.value)} /></label>
   <label>To <input aria-label="Bets to date" type="date" value={to} onChange={e=>setTo(e.target.value)} /></label>
  </div>
  {loading&&<p role="status">Refreshing bets…</p>}
  {error&&<p role="alert">{error}</p>}
  {data&&<>
   <div className="sr-tiles">{[
    ['Bets',String(data.summary.selected)],['Settled',String(data.summary.settled)],['Strike rate',data.summary.settled?fmt(data.summary.wins/data.summary.settled*100,'%'):'—'],['ROI',fmt(data.summary.roi_pct,'%')],['Profit',reportUnits(streamId,data.summary.pnl_units)],['Pending',String(data.summary.pending)]
   ].map(([label,value])=><div className="sr-tile" key={label}><div className="sr-tile-val">{value}</div><div className="sr-tile-label">{label}</div></div>)}</div>
   <p>{data.summary.wins} winners / {data.summary.settled} settled · {data.summary.priced_bets} priced · ROI {fmt(data.summary.roi_pct,'%')} · {reportUnits(streamId,data.summary.pnl_units)} · {data.summary.pending} pending · {data.summary.voids} void · {data.summary.missing_price} missing BSP</p>
   <p style={{fontSize:12,color:'#59616d'}}>{isFlatReport(streamId)?'Flat A$100 per bet, simulated across all history.':'One unit per bet.'} Times are Sydney time. Replay Core uses the shared historical-form inputs; its rank can differ from the race page.</p>
   <div style={{overflowX:'auto'}}>
    <table className="sr-table" style={{width:'100%'}}>
     <thead><tr><th>Date</th><th>Time</th><th>Race</th><th>Runner</th><th>Replay rank</th><th>Brain %</th><th>Result</th><th>BSP</th><th>Stake</th><th>P&amp;L</th></tr></thead>
     <tbody>{rows.map(r=><tr key={r.race_id}>
      <td>{r.date}</td><td>{r.off_at?new Intl.DateTimeFormat('en-AU',{timeZone:'Australia/Sydney',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date(r.off_at)):'—'}</td>
      <td>{r.track} R{r.race}</td><td>{r.runner}</td><td>{r.core_rank}</td><td>{fmt(r.brain_prob*100,'%')}</td>
      <td style={{color:r.result==='WIN'?'#087443':r.result==='LOSS'?'#b42318':'#59616d',fontWeight:700}}>{r.result}</td>
      <td>{fmt(r.bsp)}</td><td>{isFlatReport(streamId)?reportMoney(r.result==='VOID'?0:FLAT_REPORT_STAKE):'1u'}</td><td>{reportUnits(streamId,r.benchmark_pnl_units)}</td>
     </tr>)}</tbody>
    </table>
   </div>
   {!data.rows.length&&<p>{sample==='prospective'?'No prospective bets recorded yet. Qualifying races are checked before the start.':'No backdated bets in this date range.'}</p>}
   {data.rows.length>100&&<div style={{display:'flex',gap:12,alignItems:'center',marginTop:10}}>
    <button disabled={page===0} onClick={()=>setPage(p=>p-1)}>Previous</button>
    <span>Page {page+1} of {Math.ceil(data.rows.length/100)}</span>
    <button disabled={(page+1)*100>=data.rows.length} onClick={()=>setPage(p=>p+1)}>Next</button>
   </div>}
  </>}
 </div>;
}
